import React, { useEffect, useState, useCallback} from "react";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import Product3 from "../components/Product3";
import Star from "../components/Star";
import Nodata from "../components/NoData";
import {alert, confirm} from "../components/MegConfirmAlert";
import { useTranslation } from 'react-i18next';
import { useAxios } from "../services/useAxios";
import ImageViewer from 'react-simple-image-viewer';
import Modal from 'react-bootstrap/Modal';
import ReviewModify from "./ReviewModify"

export default function ReviewFin() {
    const { t } = useTranslation();
    const [data, setData] = useState({});
    const [dataList, setDataList] = useState([]);
    const [request] = useAxios();
    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [imgList, setImgList] = useState([]);

    const [reviewInfo, setReviewInfo] = useState({});
    const [isReviewOpen, setReviewOpen] = useState(false);

    
    const [posReviewCnt, setPsReviewCnt] = useState(0);
    const [endReviewCnt, setEndReviewCnt] = useState(0);
    

    const fn_clickImg = useCallback((list,index) => {       
        let tempList = [];
        list.forEach(function (value, index) {
            tempList.push("https://www.salee.co.kr/com/cmm/getGoodsBbsNttImage.sale?bbsSn=3&atchmnflSn="+value.atchmnflSn)
        });
        setImgList(tempList)
        setCurrentImage(index);
        setIsViewerOpen(true);
      }, []);
    
      const closeImageViewer = () => {
        setCurrentImage(0);
        setIsViewerOpen(false);
      };

      
    const fn_clickPen = (obj) => {
        
        setReviewInfo(obj)
        setReviewOpen(true)
    }
    const fetchData = async () => {
       
        const response = await request.post("/app/mypage/getMySaleeReviewListAPI", {
        });

        if(response.data.resultCode === 200){

            console.log(response.data.result.resultList)
            setDataList(response.data.result.resultList.filter((el) => el.reviewAt === "Y"))
            setPsReviewCnt(response.data.result.resultList.filter((el) => el.reviewAt === "N").length)
            setEndReviewCnt(response.data.result.resultList.filter((el) => el.reviewAt === "Y").length)
            setData(response.data.result);          
                  
        }
    };
    useEffect(() => {
        fetchData();        
      }, []);

    return (
        <div>
            <div className="backGround bgBlue"></div>
            <div className="headFixed backGround bgBlue">
                <Header type="cart" pageTitle={t(`Message.my_goods_review_list_title`)}/>
                <div className="tabArea">
                <Link to="/Review" className="tabBtn">{t(`Message.my_goods_review_list_tab1` , {reviewTargetCnt : posReviewCnt})}</Link>
                <Link to="/ReviewFin" className="tabBtn active">{t(`Message.my_goods_review_list_tab2` , {reviewEndCnt : endReviewCnt})}</Link>
                </div>
            </div>

            <div className="hdTabContWr">
                {dataList && dataList.length === 0?(
                 <div className="floatCenter">
                    <Nodata text={t(`Message.my_goods_review_end_list_empty`)}/>
                </div>  
                ):(    
                <ul className="reviewWriteList">
                    {dataList && dataList.map((obj, index) => (
                    <li key={index}>
                        <Product3 
                            type="type8"
                            img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}                           
                            prodName={obj.goodsNm}
                            obj = {obj}
                            option={obj.firstOptnNm+ " "+ obj.firstOptnValue + " X "+  obj.orderQy}
                            clickPen={fn_clickPen}
                        />
                        <div className="myReview">
                            <div className="dfcsG20">
                                <Star type="long" grad0={!obj.aditfield3}  
                                grad1={(obj.aditfield3 ==="1")}  
                                grad2={(obj.aditfield3 ==="2")}
                                grad3={(obj.aditfield3 ==="3")}
                                grad4={(obj.aditfield3 ==="4")}
                                grad5={(obj.aditfield3 ==="5")}
                             num={obj.aditfield3}/>
                                <p className="cDisa left10Dash fs14">{t(`Message.my_goods_review_end_list_reg_de`)} {obj.frstRegistDt}</p>
                            </div>
                            <div className="contWr">
                                <p className="cBlack">{obj.nttCn}</p>
                            </div>
                            <div className="photoWr">
                                {obj.atchmnflList && obj.atchmnflList.map((file, index2) => (
                                    <div key={index2}>
                                    {file.atchmnflSn?(
                                    <img onClick={ () => fn_clickImg(obj.atchmnflList,index2)  } src={"https://www.salee.co.kr/com/cmm/getGoodsBbsNttImage.sale?bbsSn=3&atchmnflSn="+file.atchmnflSn} alt={"첨부이미지"+index} />
                                    ):null}
                                    </div>
                                ))}                                 
                            </div>
                        </div>
                    </li>
                     ))}  
                    
                </ul>
                 )}

                 {isViewerOpen && (
                    <ImageViewer
                    src={ imgList }
                    currentIndex={ currentImage }
                    disableScroll={ false }
                    closeOnClickOutside={ true }
                    onClose={ closeImageViewer }
                    />
                )}

            <Modal
                className="btModal"
                show={isReviewOpen}
                onHide={setReviewOpen}
                fullscreen={true}
                aria-labelledby="contained-modal-title-vcenter"
                centered                
                keyboard={false}
                >            
                <ReviewModify modal={true}  closeFn={setReviewOpen}  obj={reviewInfo}  ></ReviewModify>
            </Modal>
            </div>
        </div>
    );
};
